import UserManagement from "../features/user-management/UserManagement";

export default function UserManagementPage() {
  return (
    <div style={{ marginTop: 10 }}>
      <UserManagement />
    </div>
  );
}
